import { type TeamChatPoster } from '@littlebird/sdk';
import { useNavigate } from '@tanstack/react-router';

import { SidebarListItemFrame } from '@/components/blocks/Layout/Sidebar/SidebarListItemFrame';
import { type SidebarSectionName } from '@/components/blocks/Layout/Sidebar/sticky-section';
import { SidebarRow } from '@/design-system-v2/sidebar-row';

import { TeamChatFaces } from './team-chat-faces';

export function TeamChatSidebarItem({
  section,
  projectId,
  chatId,
  title,
  posters,
  unread,
  isSectionBoundary,
  hasFollowingSection,
}: {
  readonly section: SidebarSectionName;
  readonly projectId: string;
  readonly chatId: string;
  readonly title: string;
  readonly posters: readonly TeamChatPoster[];
  readonly unread: boolean;
  readonly isSectionBoundary: boolean;
  readonly hasFollowingSection: boolean;
}) {
  const navigate = useNavigate();
  return (
    <SidebarListItemFrame
      section={section}
      isSectionBoundary={isSectionBoundary}
      hasFollowingSection={hasFollowingSection}
    >
      <SidebarRow.Button
        leading={null}
        className={unread ? 'font-medium text-foreground' : undefined}
        onClick={() =>
          void navigate({
            to: '/projects/$projectId/shared/$itemType/$itemId',
            params: { projectId, itemType: 'chat', itemId: chatId },
          })
        }
        trailing={
          <span className="flex shrink-0 items-center gap-1.5">
            <TeamChatFaces posters={posters} />
            {unread && <SidebarRow.StatusDot state="unread" />}
          </span>
        }
      >
        {title}
      </SidebarRow.Button>
    </SidebarListItemFrame>
  );
}
